export var includesAny = function (source, targets) {
    return targets.some(function (target) { return source.includes(target); });
};
